export const BASIC_GROUPS = ['Affiliate', 'Catalog', 'Invoices', 'Settings', 'PO'];
export const BASIC_PATHS = ['/referal-users', '/vendors', '/account'];

export const COMMON_ROUTES = ['/user-invoices', '/account', '/users', '/file-upload-history', '/employees', '/database'];
export const VALID_WAREHOUSE_ROUTES = ['/dashboard', '/po-warehouse', '/shipping', 'po-warehouse-details', '/warehouse-work-orders', '/warehouse-location', '/location-names', '/clients', '/employees', '/po-details-mobile', '/po-mobile', '/test-workorder', '/user-test-workorder', ...COMMON_ROUTES];
export const VALID_USER_ROUTES = ['/sales', '/catalog-jobs', '/inventory/sku', '/inventory/products', '/inventory/vendor', '/vendors', '/po-history', '/work-orders', '/billing', '/confirm-placement', '/placement-option', '/sourcing', '/sourcing/catalog', '/database', '/test-workorder', '/user-test-workorder', ...COMMON_ROUTES];
export const VALID_SELLER_PLUS_WAREHOUSE_ROUTES = [...VALID_WAREHOUSE_ROUTES, ...VALID_USER_ROUTES];
export const INACTIVE_RESTRICTED_ROUTES = [
  '/work-orders',
  '/placement-option/',
  '/confirm-placement/',
  '/shipping/',
  '/po-history'
];
export const MOBILE_ROUTES = ['/po-mobile', '/po-warehouse-details', '/po-details-mobile']; 

export const PERMISSION_MAP = {
  1: 'inventory',
  2: 'purchasing',
  3: 'logistics',
  4: 'settings',
  5: 'fileHistory',
  6: 'dashboard',
  7: 'clients',
  8: 'location',
  9: 'catalog'
};
